import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { AppComponent } from "./app.component";
import { routes } from "./app.routes";
import { SharedService } from "./common/shared.service";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { LocalIpInterceptor } from './interceptors/local-ip.interceptor';
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { AuthGuard } from "./interceptors/auth.guard";
import { ComponentsModule } from "./components/components.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MasksModule } from "./masks/masks.module";
import { AppErrorHandler } from "./utils/app-error.handler";
import { UsuarioService } from "./modules/seguranca/usuario/usuario.service";
import { SharedModule } from "primeng/components/common/shared";
import { PermissaoGuard } from "./interceptors/permissao.guard";
import { PermissaoCrudGuard } from "./interceptors/permissao-crud.guard";
import locatePt from "@angular/common/locales/pt";

registerLocaleData(locatePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    ComponentsModule,
    BrowserModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    MasksModule,
    routes,
    BrowserAnimationsModule,
  ],
  providers: [
    SharedService,
    AuthGuard,
    PermissaoGuard,
    PermissaoCrudGuard,
    UsuarioService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LocalIpInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
